<template>

<div id="header">
  <!-- 모바일 전용 헤더 -->
  <div class="top_m mobile" >
    <img src="/images/common/menu_m.png" class="m_menu" @click="toggle">
    <div class="top_title">
      <a href="/front/main/main"><img src="/images/common/via_logo.png" class="header_logo" ></a> <!--@click="$router.push('/main/main')"-->
    </div>
  </div>
	<!-- top line 로그인 회원가입 -->
	<div id="lmenu_wrap"> <!--lmenu_wrap :: 모바일 전용 (왼쪽메뉴) -->

    <div class="top">
      <div class="container">
          <ul>
            <li class="remote pc"><a @click="goRemotPage">원격지원</a></li>
          </ul>
          <ul  class="top_userinfo">
            <template v-if="_config.IS_LOCAL">
              <li class="pc name" style="margin-right: 10px;"><router-link to="/sample/중요변수들" style="padding-left: 5px; padding-right: 5px; color: gray;">(개발전용) sample</router-link></li>
            </template>

            <!-- <template v-if="$store.getters['session/isLogin']">
              <li class="pc" @click="$refs.devMemo.open()" style="margin-right: 10px; background-color: #000000;" ><a style="color: orange; padding-left: 5px; padding-right: 5px;">개발메모
                <template v-if="devStatus"><small style="color: #8EE47F; font-weight: bold; ">({{ devStatus }})</small></template>
              </a></li>
              <li class="pc" @click="$refs.helpMemo.open()" style="margin-right: 10px; background-color: #000000"><a style="color: orange; padding-left: 10px; padding-right: 10px;">도움말
                <template v-if="helpStatus"><small style="color: #8EE47F; font-weight: bold;">({{ helpStatus }})</small></template>
              </a></li>
            </template> -->

            <template v-if="isLogin">
              <li class="pc name">
                <b>{{ user.id }} </b>
                  <template v-if="user.type == 'self'">
                    <b>개인변호사</b> {{ user.name }}({{ user.membno }})
                  </template>
                  <template v-if="user.type == 'member'">
                    <span>{{ user.officenm }}({{ T.trim(user.officecno) }})</span> |
                    <b>소속</b> {{ user.name }}({{ user.membno }})
                  </template>
                  <template v-if="user.type == 'master'">
                    "{{ user.name }}({{ T.trim(user.membno) }})"의 마스터
                  </template>
              </li>
              <li class="pc" ><a class="member" @click="go1('mypage', '/mypage/qna')"> 마이페이지</a></li>
              <li class="mobile" ><a class="member" @click="go1('mypage', '/mypage/qna')"> {{ user.id }} ({{ user.name }})</a></li>
              <li><router-link :to="_config.LOGOUT_PATH"  class="login">로그아웃</router-link></li>
            </template>

            <template v-else>
              <li><router-link to="/member/join" class=" member">회원가입</router-link></li>
              <li><router-link :to="_config.LOGIN_PATH" class="login">로그인</router-link> </li>
            </template>

            <!-- <li><router-link to="/mypage/remote">원격지원</router-link></li> -->



          <span @click="toggle" class="icon_close"></span>

          </ul>
      </div>
    </div>


      <!-- 상단 메뉴  -->
      <div class="gnb_wrap">
          <div class="logo_w">
              <div class="container">
                <img src="/images/common/via_logo.png" class="header_logo" @click="$router.push('/main/main')">
              </div>
          </div>
        <div class="container">
          <ul>
            <li class="d03" :class="{on: _smenu == 'mypage' }" v-show="$mq === 'mobile'">
              <dt @click="go1('mypage', '/mypage/qna')">마이페이지</dt>

              <router-link tag="dd" to="/mypage/qna" :class="{on: /\/qna_/.test(path) }" >1:1 질의응답</router-link>
              <router-link tag="dd" to="/mypage/setting_master" v-if="$store.state.session.user.type == 'master'">소속변호사 권한 설정</router-link>
              <router-link tag="dd" to="/mypage/myreqlist">신청내역확인</router-link>
              <router-link tag="dd" :to="_config.LOGOUT_PATH" v-if="isLogin">로그아웃</router-link>
            </li>

            <li class="d01" :class="{on: _smenu == 'info'   }">
              <dt @click="go1('info', '/info/info_kind')">경유증표안내</dt>

              <router-link tag="dd" to="/info/info_kind">경유증표 종류</router-link>
              <router-link tag="dd" to="/info/info_law">관련 규정</router-link>
              <router-link tag="dd" to="/board/faq">FAQ <small>자주묻는 질문</small></router-link>
            </li>
            <li class="d02" :class="{on: _smenu == 'board'  }">
              <dt @click="go1('board', '/board/board_list')">공지사항</dt>

              <router-link tag="dd" to="/board/board_list">공지사항</router-link>
            </li>
            <li class="d03" :class="{on: _smenu == 'buy'    }">
              <dt @click="go1('buy', '/buy/buy_form')">증표 구입</dt>

              <router-link tag="dd" to="/buy/buy_form" :class="{on: path == '/buy/buy_ok'}">증표 구입</router-link>
              <router-link tag="dd" to="/buy/buy_list">증표 구입 내역</router-link>
              <router-link tag="dd" to="/buy/buy_receipt_list">기간별 영수증 출력</router-link>
            </li>
            <li class="d03" :class="{on: _smenu == 'use'    }">
              <dt @click="go1('use', '/use/use_via')">증표 <font>사용</font>·조회·수정</dt>

              <router-link tag="dd" to="/use/use_via">증표 사용</router-link>
              <router-link tag="dd" to="/use/edit_via">증표 사용 내역 조회·수정</router-link>
            </li>
            <li class="d05" :class="{on: _smenu == 'apply'  }">
              <dt @click="go1('apply', '/apply/viafree_req')">신고·신청</dt>

              <router-link tag="dd" to="/apply/viafree_req" :class="{on: path == '/apply/viafree_choffice'}">면제증표 신청</router-link>
              <router-link tag="dd" to="/apply/ch_owner">미사용 증표 전환 신청 <br class="pc" />(명의변경)</router-link>
              <router-link tag="dd" to="/apply/refund">미사용 증표 환불 신청</router-link>
              <router-link tag="dd" to="/apply/wrong_change_req">오사용 증표 정정 신청</router-link>
              <!-- <router-link tag="dd" to="/apply/ch_online">오프라인증표 교환 신청</router-link> -->
              <router-link tag="dd" to="/apply/stat_list">신청내역 확인</router-link>
              <router-link tag="dd" to="/apply/return_req_req">수임사건 신고</router-link>
            </li>
            <li class="d03" :class="{on: _smenu == 'report' }">
              <dt @click="go1('report', '/report/report_viacnt')">수임사건 내역 조회</dt>

              <router-link tag="dd" to="/report/report_viacnt">수임사건 건수 조회</router-link>
              <router-link tag="dd" to="/report/report_viadetail">수임사건 상세 조회</router-link>
              <router-link tag="dd" to="/report/report_viacancel">수임사건 사임/취하<br class="pc" /> 건수 조회</router-link>
            </li>
            <a href="https://www.seoulbar.or.kr/"><li class="d_seoul">서울지방변호사회 홈페이지</li></a>
          </ul>
        </div> <!-- // container -->
      </div> <!-- //.gnb_wrap -->
      <div v-if="!hideSubTop" class="sub_top">
			</div>

		<div class="m_toptit_bg"></div> <!-- mobile전용  title bg -->
		<div class="btn_mback" onclick="history.go(-1);"><img src="/images/common/btn_mback01.png"></div> <!--  MOBLIE : 뒤로가기 -->
	<!-- 상단 메뉴 끝 -->
</div>

  <!-- <dev-comment-editor ref="devMemo" v-if="$store.getters['session/isLogin']" :devStatus.sync="devStatus"/> -->
  <!-- <help-comment-editor ref="helpMemo" v-if="$store.getters['session/isLogin']" :helpStatus.sync="helpStatus"/> -->
</div>



</template>


<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    // 'dev-comment-editor' : require('@/components/DevCommentEditor.vue').default,
    // 'help-comment-editor' : require('@/components/HelpCommentEditor.vue').default,
  },
  props : {
    hideSubTop: {
        type: Boolean,
        default: false
    },
  },
  data() {
    return {
      mobileSmenu: '',
      devStatus: '',
      helpStatus :'',
    }
  },
  computed: {
    _smenu() { return this.$mq == 'mobile' ? this.mobileSmenu : this.$route.meta.smenu },
    ...mapGetters('session', ['user', 'isLogin']),
    path() { return this.$route.path },
    loginTypeName() {
      switch (this.$store.state.session.user.type) {
        case "self": return "개인변호사"
        case "member": return "소속"
        case "master": return "마스터"
      }
      return ""
    },
  },
  mounted() {
    // if (this.$device.isMobile) {
      $('#lmenu_wrap ul li dd').click(this.toggle)
      this.setHover()
    // }
  },
  watch: {
    '$mq'(v) {
      switch(v) {
        case 'desktop':
          this.setHover()
          return $('#lmenu_wrap').show()
        case 'mobile' :
          this.mobileSmenu = this.$route.meta.smenu // 모바일로 전환시 현재 페이지의 smenu복사
          $('#header .gnb_wrap').off('mouseenter mouseleave').height("100%")
          return $('#lmenu_wrap').hide()
      }
    },
    '$route': 'setHover',
  },
  methods: {
    toggle() {
      if (this.$mq === 'mobile') {
        $('#lmenu_wrap').toggle();
      } else {
        $('#header .gnb_wrap').height("90px")
      }
    },
    setHover() {
      if (this.$mq == 'desktop') {
        $('#header .gnb_wrap')
          .off('mouseenter mouseleave')
          .height("90px")
          .hover(()=>{
              $('#header .gnb_wrap').height("305px")
          },()=> {
              $('#header .gnb_wrap').height("90px")
          })
      }
    },

    goRemotPage() {
      if (confirm("원격지원 페이지로 이동하시겠습니까 ?")) {
        window.open("https://939.co.kr/sbar/", '_blank');
      }
    },

    go1(smenu, path) {
      switch(this.$mq) {
        case 'desktop': return this.$router.push(path) // 데스크탑 모드일땐 무조건 해당 링크로 이동
        case 'mobile' : return this.mobileSmenu = this.mobileSmenu == smenu ? '' : smenu // 모바일일땐 토글기능
      }
    },
  },
}


</script>
